<app-z-dialog
  [title]="data.title | translate"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <section class="d-flex flex-column align-items-center">
    <mat-icon [style.color]="data.iconColor">
      {{ data.icon }}
    </mat-icon>
    <h2 mat-dialog-title>{{ data.title | translate }}</h2>
    <p>{{ data.message | translate }}</p>
  </section>
</ng-template>
<ng-template #buttonsTemplate>
  @for (button of data.buttons; track $index) {
    <z-button
      [color]="button.color"
      [class]="button.class"
      [icon]="button.icon || 'brightness_low'"
      [label]="button.label | translate"
      [matTooltip]="button.label | translate"
      (click)="confirm(button.value)"
    >
    </z-button>
  }
</ng-template>
